/* AOV 20 — "Make it yours" personaliser (snippets/runit-personalise.liquid).

   Instagram handle or custom text, centred under the back design. All text uses the
   owner's proven HAZLEY-SHAKES 10.2mm capital height, independent of design/garment size.
   The Instagram icon stays proportional; footer detection controls placement only.
   The line is drawn on a canvas over the photo. Reflective uses the RunIt dashboard's mockup glow
   exactly (runit-dashboard lib/mockups/mockupRender.ts): draw the design, then draw it again with
   blur 0.1, 1 and 10px at 2048px scale, stacked. The same drawing makes the snapshot for the order.

   Stars (hoodies): five down each sleeve, measured from the WANTED BY WEST YORKSHIRE POLICE mockup
   (fractions of the photo), filled from the cuff up: 3 lit + 2 grey or 5 lit. Lit stars are plain yellow
   or reflective white (owner, 3 Nov; was both reflective, 22 Oct; same price) (the gold star's shape refilled, with the reflective glow;
   owner 20 Oct), £10 either way.

   Number plate: a UK motorbike plate (square, two lines) centred under the design, copied from the
   'number plate' layer in hoodies.psd, drawn like the ANPR THIS design: thin amber outline, black gap,
   filled amber plate with small rounded corners, black characters, in UKNumberPlate (freeware, Gareth Attrill; assets/runit-uknumberplate.woff2,
   subset to A-Z 0-9).

   The preview follows the chosen variant (Print Finish): data-variant-media maps variant id to its
   photo and price, and the mobile sticky bar shows garment + personalisation as one total. */
(function () {
  // Owner standard 27 Oct: all handles/custom text use the proven HAZLEY-SHAKES
  // 10.2mm capital height. Canonical hoodie mockup: 540px design / 300mm on a
  // 1400px photo. This garment-photo calibration stays independent of artwork.
  // Armoured photos retain their measured 0.8 garment-photo factor.
  var SLANT = Math.tan(12 * Math.PI / 180),
    TEXT_CAP_MM = 10.2,
    CAP_H = TEXT_CAP_MM * (540 / 300) / 1400,
    GAP = 0.018, ICON_RATIO = 1.5, SPACE = CAP_H * (0.008 / 0.0184);
  var BLUR_RADII = [0.1, 1, 10], REF = 2048; // dashboard: lib/mockups/placements.ts
  var FALLBACK = 0.64; // print bottom when the photo can't be read
  var FONT = 'RunItPersonalisation', CAP = 0.7, fontReady = !document.fonts;
  // Exact cmap of the complete cutter font. Unsupported characters must never use browser fallback.
  var TEXT_GLYPHS = " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\u00a0\u00a1\u00a2\u00a3\u00a4\u00a5\u00a6\u00a7\u00a8\u00a9\u00aa\u00ab\u00ac\u00ae\u00af\u00b0\u00b1\u00b2\u00b3\u00b4\u00b5\u00b6\u00b7\u00b8\u00b9\u00ba\u00bb\u00bc\u00bd\u00be\u00bf\u00c0\u00c1\u00c2\u00c3\u00c4\u00c5\u00c6\u00c7\u00c8\u00c9\u00ca\u00cb\u00cc\u00cd\u00ce\u00cf\u00d0\u00d1\u00d2\u00d3\u00d4\u00d5\u00d6\u00d7\u00d8\u00d9\u00da\u00db\u00dc\u00dd\u00de\u00df\u00e0\u00e1\u00e2\u00e3\u00e4\u00e5\u00e6\u00e7\u00e8\u00e9\u00ea\u00eb\u00ec\u00ed\u00ee\u00ef\u00f0\u00f1\u00f2\u00f3\u00f4\u00f5\u00f6\u00f7\u00f8\u00f9\u00fa\u00fb\u00fc\u00fd\u00fe\u00ff\u0100\u0101\u0102\u0103\u0104\u0105\u0106\u0107\u0108\u0109\u010a\u010b\u010c\u010d\u010e\u010f\u0110\u0111\u0112\u0113\u0114\u0115\u0116\u0117\u0118\u0119\u011a\u011b\u011c\u011d\u011e\u011f\u0120\u0121\u0122\u0123\u0124\u0125\u0126\u0127\u0128\u0129\u012a\u012b\u012c\u012d\u012e\u012f\u0130\u0131\u0132\u0133\u0134\u0135\u0136\u0137\u0138\u0139\u013a\u013b\u013c\u013d\u013e\u013f\u0140\u0141\u0142\u0143\u0144\u0145\u0146\u0147\u0148\u0149\u014c\u014d\u014e\u014f\u0150\u0151\u0152\u0153\u0154\u0155\u0156\u0157\u0158\u0159\u015a\u015b\u015c\u015d\u015e\u015f\u0160\u0161\u0162\u0163\u0164\u0165\u0166\u0167\u0168\u0169\u016a\u016b\u016c\u016d\u016e\u016f\u0170\u0171\u0172\u0173\u0174\u0175\u0176\u0177\u0178\u0179\u017a\u017b\u017c\u017d\u017e\u01fc\u01fd\u01fe\u01ff\u0218\u0219\u021a\u021b\u0237\u02bc\u02c6\u02c7\u02d8\u02d9\u02da\u02db\u02dc\u02dd\u0401\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041a\u041b\u041c\u041d\u041e\u041f\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042a\u042b\u042c\u042d\u042e\u042f\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043a\u043b\u043c\u043d\u043e\u043f\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044a\u044b\u044c\u044d\u044e\u044f\u0451\u1e02\u1e03\u1e0a\u1e0b\u1e1e\u1e1f\u1e40\u1e41\u1e56\u1e57\u1e60\u1e61\u1e6a\u1e6b\u1e80\u1e81\u1e82\u1e83\u1e84\u1e85\u1ef2\u1ef3\u2012\u2013\u2014\u2018\u2019\u201a\u201c\u201d\u201e\u2020\u2021\u2022\u2026\u2030\u2039\u203a\u2044\u2070\u2074\u2075\u2076\u2077\u2078\u2079\u2080\u2081\u2082\u2083\u2084\u2085\u2086\u2087\u2088\u2089\u20ac\u20b9\u2117\u2122\u2153\u2154\u215b\u215c\u215d\u215e\u2212\u221e\u2248";
  var STAR_W = 0.062; // star width as a fraction of the photo width
  var STARS_LEFT = [[0.189, 0.728], [0.199, 0.661], [0.209, 0.595], [0.220, 0.527], [0.231, 0.461]];
  var STARS_RIGHT = [[0.812, 0.734], [0.801, 0.667], [0.791, 0.601], [0.780, 0.533], [0.769, 0.467]];
  // Armoured zip hoodie photos (data-pz-shape="armoured"): the garment sits a little larger and the
  // sleeves hang apart from the body, so the stars follow each sleeve's measured centre line on the
  // Armoured_Back blank, same heights as above. The back designs print at ~0.8x the standard hoodie's
  // size in these photos (NO HESI, BAD INFLUENCE, LOUD PIPES ... measured side by side), so the default
  // handle / text / plate sizes scale by ARMOURED_K to keep the same ratio to the design.
  var ARMOURED_STARS_LEFT = [[0.168, 0.737], [0.175, 0.670], [0.184, 0.603], [0.195, 0.536], [0.204, 0.469]];
  var ARMOURED_STARS_RIGHT = [[0.830, 0.737], [0.823, 0.670], [0.814, 0.603], [0.803, 0.536], [0.793, 0.469]];
  var ARMOURED_K = 0.8;
  // Plate, from hoodies.psd (1960px): 195 x 144 plate, 50px under the design, 8px yellow frame,
  // 2.5px black keyline, text block 70% of the plate height.
  var AMBER = '#fec40e'; // number plate and lit stars
  var PLATE_W = 0.0995, PLATE_RATIO = 144 / 195, PLATE_GAP = 0.0255, PLATE_FRAME = 0.041, PLATE_LINE = 0.013;
  // The plate is allowed to sit low, but never past the garment's hem: it is clamped to
  // GARMENT_BOTTOM - PLATE_MARGIN, i.e. a little above the bottom edge (merchant 2026-09-29).
  var GARMENT_BOTTOM = 0.95, PLATE_MARGIN = 0.012;
  var PLATE_FONT = '{s}px RunItUKPlate, Oswald, "Arial Narrow", sans-serif', PLATE_CAP = 1400 / 2048; // UKNumberPlate cap height / em
  // Safari (every iPhone browser) accepts ctx.filter but draws nothing with it, so the reflective glow
  // (handle, text and Reflective White stars) was missing there (9 Oct). Where a blur doesn't render,
  // glow() draws the same radii as a white shadow instead.
  var FILTER_OK = (function () {
    try {
      var c = document.createElement('canvas'); c.width = c.height = 20;
      var g = c.getContext('2d'); g.filter = 'blur(3px)'; g.fillStyle = '#fff'; g.fillRect(8, 8, 4, 4);
      return g.getImageData(4, 10, 1, 1).data[3] > 0;
    } catch (e) { return false; }
  })();
  function loadImg(src) { var i = new Image(); i.crossOrigin = 'anonymous'; i.src = src; return i; }

  function $(root, sel) { return root.querySelector(sel); }
  // RLPZ_ON is every live personaliser together: a set has one per piece (assets/runit-armour-bundles.js
  // marks the ones not in play data-pz-off), so one piece switching off can't clear another's 'made'.
  function recount() {
    var on = false;
    document.querySelectorAll('[data-runit-personalise][data-pz-on]:not([data-pz-off])').forEach(function (r) {
      var v = r.dataset.pzOn; if (v === 'made' || (v && !on)) on = v;
    });
    if ((window.RLPZ_ON || false) !== on) {
      window.RLPZ_ON = on;
      document.dispatchEvent(new CustomEvent('runit:personalise', { detail: { on: on } }));
    }
  }
  window.rlPzRecount = recount;

  // Roots arrive late too: the collection quick-add modal injects the product HTML after load.
  function initAll() { document.querySelectorAll('[data-runit-personalise]:not([data-pz-ready])').forEach(init); }
  function init(root) {
    var form = document.getElementById(root.dataset.form);
    if (!form) return;
    root.setAttribute('data-pz-ready', '');
    var scope = root.closest('quick-add-modal') || document; // the product's own title and options, not the page's
    var base = $(root, '[data-pz-base]'), layer = $(root, '[data-pz-layer]');
    // A closed details panel must not defer the preview download until it opens.
    // Keep it below the main gallery in network priority until the shopper needs it.
    base.loading = 'eager';
    base.fetchPriority = 'low';
    var fields = $(root, '[data-pz-fields]'), msg = $(root, '[data-pz-msg]');
    var inIg = $(root, '[data-pz-input-ig]'), inText = $(root, '[data-pz-input-text]'), inPlate = $(root, '[data-pz-input-plate]');
    var inRefl = $(root, '[data-pz-refl]'), inAgree = $(root, '[data-pz-agree]');
    var priceEl = $(root, '[data-pz-price]');
    var agreeBox = inAgree && inAgree.closest ? inAgree.closest('.rl-pz__agreement') : null, agreeErr = false;
    var AGREE_MSG = 'Please tick the box to confirm personalised items can’t be returned unless faulty.';
    // Done (set editor, configurator) asks first: false = not ticked, now shown in red with focus on the box.
    root.rlPzRequireAgree = function () {
      var error = lineError();
      if (error) { msg.textContent = error; root.open = true; return false; }
      if (!any() || inAgree.checked) return true;
      agreeErr = true; render();
      root.open = true; inAgree.focus({ preventScroll: true });
      (agreeBox || inAgree).scrollIntoView({ block: 'center', behavior: 'smooth' });
      return false;
    };
    var summaryEl = $(root, '[data-pz-summary]'), addedEl = $(root, '[data-pz-added]');
    var armoured = root.dataset.pzShape === 'armoured', K = armoured ? ARMOURED_K : 1;
    var CENTRE = root.dataset.pzCentre === '1'; // centre on the whole design (snippets/runit-personalise.liquid)
    var TEXT_GAP = parseFloat(root.dataset.pzTextGap) || 1; // placement only; never scales letters/icon
    var GAPK = parseFloat(root.dataset.pzGap) || 1; // per-design gap under the print (snippet: rpz_gap)
    var BAND = parseFloat(root.dataset.pzBand) || 0.3; // left edge of the strip the print's bottom is read in (snippet: rpz_band)
    var starsL = armoured ? ARMOURED_STARS_LEFT : STARS_LEFT, starsR = armoured ? ARMOURED_STARS_RIGHT : STARS_RIGHT;
    var props = {};
    root.querySelectorAll('[data-pz-prop]').forEach(function (el) { props[el.dataset.pzProp] = el; });

    // Personalisation variants by title: 'Instagram', 'Reflective Custom Text + 5 Stars', ...
    var VARIANTS = {};
    (root.dataset.variants || '').split('|').forEach(function (row) {
      var p = row.split('='); if (p.length === 3) VARIANTS[p[0]] = { id: +p[1], price: +p[2] };
    });
    var st = { kind: '', ig: '', text: '', plate: '', refl: false, stars: '', starCol: 'yellow' };
    // Variant id -> { price, img } for the preview and the sticky total.
    var MEDIA = {};
    (root.dataset.variantMedia || '').split('|').forEach(function (row) {
      var p = row.split('='); if (p.length >= 3) MEDIA[p[0]] = { price: +p[1], img: p.slice(2).join('=') };
    });
    (root.dataset.variantFinishes || '').split('|').forEach(function (row) {
      var p = row.split('='); if (MEDIA[p[0]]) MEDIA[p[0]].finish = p[1];
    });
    (root.dataset.variantColours || '').split('|').forEach(function (row) {
      var p = row.split('='); if (MEDIA[p[0]]) MEDIA[p[0]].colour = p[1];
    });
    var starGold = root.dataset.starGold ? loadImg(root.dataset.starGold) : null;
    var starGrey = root.dataset.starGrey ? loadImg(root.dataset.starGrey) : null;
    var starLit = {}; // the gold star's shape refilled per colour, built once the gold image loads
    if (starGold) starGold.addEventListener('load', function () {
      [['yellow', AMBER], ['white', '#fff']].forEach(function (k) {
        var c = document.createElement('canvas'); c.width = starGold.naturalWidth; c.height = starGold.naturalHeight;
        var g = c.getContext('2d'); g.drawImage(starGold, 0, 0);
        g.globalCompositeOperation = 'source-in'; g.fillStyle = k[1]; g.fillRect(0, 0, c.width, c.height);
        starLit[k[0]] = c;
      });
      render();
    });
    function starColName() { return st.starCol === 'white' ? 'Reflective White' : 'Yellow'; } // yellow isn't reflective (owner, 3 Nov)
    if (starGrey) starGrey.addEventListener('load', function () { render(); });
    function any() { return !!(st.kind || st.stars); }
    function comboTitle() {
      var line = st.kind ? (st.refl && st.kind !== 'plate' ? 'Reflective ' : '') + { instagram: 'Instagram', text: 'Custom Text', plate: 'Plate' }[st.kind] : '';
      var stars = st.stars ? st.stars + ' Stars' : '';
      return [line, stars].filter(Boolean).join(' + ');
    }
    function combo() { return VARIANTS[comboTitle()] || null; }
    var printBottom = FALLBACK, garmentBottom = GARMENT_BOTTOM, capH = CAP_H * K, gapH = GAP * K, printX = 0.5;

    function lineError() {
      if (!st.kind || st.kind === 'plate') return '';
      var text = content();
      if (Array.from(text).some(function (ch) { return TEXT_GLYPHS.indexOf(ch) < 0; })) return 'That character cannot be printed. Please use letters, numbers or supported punctuation.';
      if (!fontReady) return 'The text preview could not load yet. Please refresh and try again.';
      return '';
    }
    function content() { return !st.kind ? '' : st.kind === 'instagram' ? (st.ig ? '@' + st.ig : '') : st.kind === 'plate' ? st.plate.trim() : st.text.trim(); }
    // The plate as it reads in the bag and the order: its two lines as 'MY / 636'.
    function plateText() { return st.plate.split('\n').map(function (l) { return l.trim(); }).filter(Boolean).join(' / '); }
    function money(p) { return '£' + (p / 100).toFixed(p % 100 ? 2 : 0); }
    function price() { var c = combo(); return c ? c.price : 0; }
    function set(k, v) { props[k].disabled = !v; props[k].value = v || ''; }

    // The handle / text line, white, centred under the print, in a W x H frame.
    function drawLine(g, W, H) {
      var txt = content();
      // Picking Instagram or Number Plate shows the logo + @ / the empty plate straight away;
      // the typed characters fill in after (owner, 10 Oct).
      if (st.kind === 'plate') return drawPlate(g, W, H, txt);
      if (!txt && st.kind === 'instagram') txt = '@';
      if (!txt) return;
      if (lineError()) return;
      var c = capH, fs = c * H / CAP, ic = st.kind === 'instagram' ? c * ICON_RATIO * H : 0, sp = ic ? SPACE * K * H : 0;
      g.font = fs + 'px ' + FONT; g.fontKerning = 'normal'; g.textBaseline = 'alphabetic';
      // Native glyph widths, with one consistent whole-line12deg slant (same as cutter).
      var lean = fs * CAP * SLANT, tw = g.measureText(txt).width, x = printX * W - (ic + sp + tw + lean) / 2;
      var cy = (printBottom + gapH * TEXT_GAP * GAPK) * H + Math.max(ic, fs * CAP) / 2;
      g.fillStyle = g.strokeStyle = '#fff';
      if (ic) {
        var iy = cy - ic / 2; g.lineWidth = ic * 0.09;
        g.beginPath();
        if (g.roundRect) g.roundRect(x + ic * 0.1, iy + ic * 0.1, ic * 0.8, ic * 0.8, ic * 0.23);
        else g.rect(x + ic * 0.1, iy + ic * 0.1, ic * 0.8, ic * 0.8);
        g.stroke();
        g.beginPath(); g.arc(x + ic / 2, iy + ic / 2, ic * 0.18, 0, 7); g.stroke();
        g.beginPath(); g.arc(x + ic * 0.73, iy + ic * 0.27, ic * 0.06, 0, 7); g.fill();
      }
      var base = cy + fs * CAP / 2;
      g.save(); g.translate(x + ic + sp, base); g.transform(1, 0, -SLANT, 1, 0, 0); // consistent whole-line slant only
      g.fillText(txt, 0, 0);
      g.restore();
    }

    // UK motorbike plate: two lines ('RUN IT' -> RUN / IT, 'TY07 DOD' -> TY07 / DOD), centred under the print.
    function drawPlate(g, W, H, txt) {
      // Styled as the ANPR THIS design: a thin amber outline, a black gap, then a filled amber plate
      // with small rounded corners; two rows of black characters (UKNumberPlate).
      // Plate: 90% of the PSD width, 1.5x the handle's gap below the print (owner 10 Oct: a little lower); the hem clamp still wins.
      var pw = PLATE_W * 0.9 * K * W, ph = pw * 0.782, x = printX * W - pw / 2, y = (printBottom + gapH * 1.5 * GAPK) * H;
      // Never past the hem. The hem is a hard limit; under the design is only a preference, so if
      // the garment is too short for both, the hem wins (merchant 2026-09-29).
      var hemLimit = (garmentBottom - PLATE_MARGIN) * H - ph, underPrint = printBottom * H + 2;
      // Too little room between the print and the hem: shrink the plate (down to half size) so it
      // fits the gap instead of the hem pushing it up over the design (BOO! DIDN'T SEE ME? GHOST
      // RIDER, owner 19 Oct). Only below half size does the old 'hem wins' overlap come back.
      var room = (garmentBottom - PLATE_MARGIN) * H - underPrint;
      if (room < ph && room >= ph * 0.5) {
        var shrink = room / ph; pw *= shrink; ph *= shrink; x = printX * W - pw / 2;
        hemLimit = (garmentBottom - PLATE_MARGIN) * H - ph;
      }
      if (y > hemLimit) y = hemLimit;
      if (y < underPrint && underPrint < hemLimit) y = underPrint;
      // Outline and gap drawn ~2x the big design's so they still read at plate size (merchant 2026-09-29).
      var lw = Math.max(2, 0.015 * pw), inset = lw + Math.max(2, 0.03 * pw);
      var rect = function (rx, ry, rw, rh, rad) { g.beginPath(); if (g.roundRect) g.roundRect(rx, ry, rw, rh, rad); else g.rect(rx, ry, rw, rh); };
      g.fillStyle = '#000'; rect(x, y, pw, ph, 0.024 * pw); g.fill();                       // black behind the gap
      g.strokeStyle = AMBER; g.lineWidth = lw; rect(x + lw / 2, y + lw / 2, pw - lw, ph - lw, 0.022 * pw); g.stroke(); // outline
      var fx = x + inset, fy = y + inset, fw = pw - 2 * inset, fh = ph - 2 * inset;
      g.fillStyle = AMBER; rect(fx, fy, fw, fh, 0.015 * pw); g.fill();                     // plate
      // The shopper's own line break (Enter) wins; otherwise split at the space, or after 4 characters.
      var parts = txt.indexOf('\n') > -1 ? txt.split('\n').map(function (l) { return l.trim(); }).filter(Boolean)
        : txt.indexOf(' ') > 0 ? [txt.slice(0, txt.indexOf(' ')), txt.slice(txt.indexOf(' ') + 1)]
        : txt.length > 4 ? [txt.slice(0, 4), txt.slice(4)] : [txt];
      var cap = fh * 0.359, gap = fh * 0.087, fs = cap / PLATE_CAP, maxW = fw * 0.9;
      g.font = PLATE_FONT.replace('{s}', fs);
      var widest = Math.max.apply(null, parts.map(function (t) { return g.measureText(t).width; }));
      if (widest > maxW) { fs *= maxW / widest; cap = fs * PLATE_CAP; g.font = PLATE_FONT.replace('{s}', fs); }
      var block = parts.length * cap + (parts.length - 1) * gap, top = fy + (fh - block) / 2;
      g.fillStyle = '#000'; g.textAlign = 'center'; g.textBaseline = 'alphabetic';
      parts.forEach(function (t, i) { g.fillText(t, fx + fw / 2, top + cap + i * (cap + gap)); });
      g.textAlign = 'start';
    }

    // Five stars down each sleeve, filled from the cuff up.
    function drawStars(g, W, H, litOnly) {
      if (!st.stars) return;
      var sw = STAR_W * W;
      [starsL, starsR].forEach(function (col) {
        col.forEach(function (pt, i) {
          var lit = st.stars === '5' || i < 3, img = lit ? starLit[st.starCol] : litOnly ? null : starGrey;
          if (!img || !(img.naturalWidth || img.width)) return;
          var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height, sh = sw * ih / iw;
          g.drawImage(img, pt[0] * W - sw / 2, pt[1] * H - sh / 2, sw, sh);
        });
      });
    }

    // Reflective glow follows the garment-photo scale used for the text.
    function glow(g, W, fn, k) {
      var scale = W / REF * (k || 1);
      BLUR_RADII.forEach(function (r) {
        if (FILTER_OK) g.filter = 'blur(' + (r * scale) + 'px)';
        else { g.shadowColor = '#fff'; g.shadowBlur = 2 * r * scale; } // a shadow's blur is ~2x the Gaussian radius
        fn();
      });
      g.filter = 'none'; g.shadowBlur = 0; g.shadowColor = 'transparent';
    }
    function paint(g, W, H) {
      drawLine(g, W, H);
      if (st.refl && st.kind !== 'plate') glow(g, W, function () { drawLine(g, W, H); }, K);
      drawStars(g, W, H);
      if (st.stars && st.starCol === 'white') glow(g, W, function () { drawStars(g, W, H, true); }); // yellow is plain yellow, no glow (owner, 3 Nov)
    }

    function draw() {
      var W = base.naturalWidth, H = base.naturalHeight;
      if (!W) return;
      if (layer.width !== W) { layer.width = W; layer.height = H; }
      var g = layer.getContext('2d');
      g.clearRect(0, 0, W, H);
      if (any()) paint(g, W, H);
    }

    function render() {
      var on = any();
      // Stock badge reads 'Made to order', 2 weeks, while personalised (runit-tweaks.js);
      // Last Sizes (data-pz-quick) 5–7 working days (merchant 2026-10-30).
      var made = on ? (root.hasAttribute('data-pz-quick') ? 'quick' : 'made') : false;
      root.dataset.pzOn = made || '';
      recount();
      // Express checkout (non-set pages) would skip this charge and the "can't be returned" tick.
      form.querySelectorAll('.rl-apple-pay').forEach(function (el) { el.toggleAttribute('data-rl-pz-on', on); });
      fields.hidden = !on;
      root.querySelectorAll('[data-pz-stars-any]').forEach(function (el) { el.hidden = !st.stars; });
      root.querySelectorAll('[data-pz-when]').forEach(function (el) { el.hidden = !st.kind || el.dataset.pzWhen.split(' ').indexOf(st.kind) < 0; });
      draw();
      var starsOnly = !!(st.stars && !st.kind);
      if (summaryEl) summaryEl.textContent = starsOnly ? st.stars + ' stars · ' + starColName() : 'Personalisation';
      if (addedEl) addedEl.hidden = starsOnly;
      priceEl.textContent = on ? (starsOnly ? '— ' : '+') + money(price()) : '';
      set('kind', on && comboTitle());
      set('instagram', st.kind === 'instagram' && st.ig && '@' + st.ig);
      set('text', st.kind === 'text' && st.text.trim());
      set('plate', st.kind === 'plate' && plateText());
      set('refl', st.kind && st.kind !== 'plate' && st.refl && 'Yes');
      set('stars', st.stars && st.stars + ' of 5 ' + starColName().toLowerCase() + ', both sleeves');
      set('place', on && [st.kind && ('Back, centred under the design' + (st.kind === 'plate' ? '' : '; text capitals ' + TEXT_CAP_MM + 'mm')), st.stars && 'Stars down both sleeves'].filter(Boolean).join('; '));
      // The agreement left unticked at Done / Add to Bag: a red box round it and a red line until it is ticked.
      if (inAgree.checked || !on) agreeErr = false;
      if (agreeBox) agreeBox.classList.toggle('rl-pz__agreement--error', agreeErr);
      msg.textContent = lineError() || (agreeErr ? AGREE_MSG : '');
      syncSticky();
      // What this personalisation adds (the add-on line's price), for a set's Add to Bag total.
      root.dataset.pzPrice = on ? price() : 0;
      root.dispatchEvent(new CustomEvent('runit:pz-change', { bubbles: true }));
    }

    root.addEventListener('change', function (e) {
      if (e.target.name === 'rl-pz-kind') st.kind = e.target.value;
      if (st.kind === 'plate' && inRefl) inRefl.checked = st.refl = false; // plates aren't reflective
      if (e.target.name === 'rl-pz-stars') st.stars = e.target.value;
      if (e.target === inRefl) st.refl = inRefl.checked;
      if (e.target.hasAttribute && e.target.hasAttribute('data-pz-star-col')) st.starCol = e.target.value;
      render();
    });
    // The row's "Added" button takes it all off again; anywhere else on the row just opens or closes it.
    var addBtn = $(root, '.rl-pz__add');
    if (addBtn) addBtn.addEventListener('click', function (e) {
      if (!any()) return;
      e.preventDefault();
      root.querySelectorAll('input[name="rl-pz-kind"][value=""], input[name="rl-pz-stars"][value=""]').forEach(function (r) { r.checked = true; });
      st.kind = st.stars = '';
      inAgree.checked = false;
      root.open = false;
      render();
    });
    inIg.addEventListener('input', function () {
      // uppercase only: the print face (Bebas) has no lowercase, so the box shows what gets printed
      var c = inIg.value.toUpperCase().replace(/^@+/, '').replace(/[^A-Z0-9._]/g, '').slice(0, 20);
      if (c !== inIg.value) { var ci = inIg.selectionStart; inIg.value = c; inIg.setSelectionRange(ci, ci); } // keep the caret mid-edit
      st.ig = c; render();
    });
    inText.addEventListener('input', function () {
      var c = inText.value.toUpperCase().slice(0, 20);
      if (c !== inText.value) { var ct = inText.selectionStart; inText.value = c; inText.setSelectionRange(ct, ct); }
      st.text = c; render();
    });
    // Plate: up to 8 characters over at most two lines; Enter starts the second line (owner, 19 Oct).
    var PLATE_MAX = +(inPlate && inPlate.dataset.pzMax) || 8;
    if (inPlate) inPlate.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && inPlate.value.indexOf('\n') > -1) e.preventDefault(); // two lines at most
    });
    if (inPlate) inPlate.addEventListener('input', function () {
      var left = PLATE_MAX, lines = inPlate.value.toUpperCase().replace(/\r/g, '').replace(/[^A-Z0-9 \n]/g, '').split('\n').slice(0, 2)
        .map(function (l) { l = l.replace(/^ +| {2,}/g, ' ').replace(/^ /, '').slice(0, left); left -= l.length; return l; });
      if (!left && lines.length > 1 && !lines[1]) lines.pop(); // full: no empty second line
      // The box breaks where the plate drawing does (drawPlate): at the space, or after 4 characters.
      if (lines.length === 1) {
        var sp = lines[0].indexOf(' ');
        if (sp > 0) lines = [lines[0].slice(0, sp), lines[0].slice(sp + 1)];
        else if (lines[0].length > 4) lines = [lines[0].slice(0, 4), lines[0].slice(4)];
      }
      var c = lines.join('\n');
      if (c !== inPlate.value) {
        var cp = inPlate.selectionStart === inPlate.value.length ? c.length : inPlate.selectionStart;
        inPlate.value = c; inPlate.setSelectionRange(cp, cp);
      }
      inPlate.rows = c.indexOf('\n') > -1 ? 2 : 1; // one line until the plate has two
      st.plate = c; render();
    });

    // The chosen variant: its photo in the preview (Print Finish), its price in the sticky total.
    function variantId() { return ((form.querySelector('[name="id"]') || {}).value || ''); }
    var warmedMedia = {};
    function warmAlternateFinish(current) {
      if (!current || !current.finish) return;
      var alternate = Object.keys(MEDIA).map(function (key) { return MEDIA[key]; }).find(function (m) {
        return m.finish !== current.finish && m.colour === current.colour && m.img !== current.img;
      });
      if (!alternate || warmedMedia[alternate.img]) return;
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.fetchPriority = 'low';
      warmedMedia[alternate.img] = image;
      image.src = alternate.img;
    }
    function followVariant() {
      var id = variantId(), m = MEDIA[id];
      var section = root.closest('quick-add-modal') || root.closest('[id^="shopify-section-"]') || document;
      var picker = section.querySelector('[data-runit-print-finish]');
      var picked = picker && (picker.querySelector('input:checked') || picker.querySelector('select'));
      var colourPicker = section.querySelector('[data-runit-print-colour]');
      var colour = colourPicker && (colourPicker.querySelector('input:checked') || colourPicker.querySelector('select'));
      // Finish can be chosen before Size, while the form still holds the old variant.
      if ((picked && (!m || m.finish !== picked.value)) || (colour && (!m || m.colour !== colour.value))) {
        var match = Object.keys(MEDIA).find(function (key) {
          return (!picked || MEDIA[key].finish === picked.value) && (!colour || MEDIA[key].colour === colour.value);
        });
        if (match) m = MEDIA[match];
      }
      if (m && m.img && base.getAttribute('src') !== m.img) base.src = m.img; // load -> findPrint -> render
      if (root.open) warmAlternateFinish(m);
      syncSticky();
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, variant-radios, secondary-variant-select, secondary-variant-select-separate, [data-runit-print-finish], [data-runit-print-colour]')) {
        followVariant();
        setTimeout(followVariant, 0); setTimeout(followVariant, 400); // after the theme swaps the id and redraws prices
      }
    });

    // Section responses replace the sticky price markup after the initial change.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, followVariant);
    }

    // Mobile sticky bar: '£50.00' becomes '£65.00' while personalisation is chosen.
    function syncSticky() {
      if (root.hasAttribute('data-pz-piece')) return; // a set's piece: the sticky bar shows the set
      syncMain();
      var box = document.querySelector('sticky-atc .sticky-atc__price');
      if (!box) return;
      var m = MEDIA[variantId()], extra = any() ? price() : 0;
      var tot = box.querySelector('[data-rl-pz-total]');
      box.classList.toggle('rl-pz-sticky-on', !!(extra && m));
      if (!extra || !m) { if (tot) tot.remove(); return; }
      if (!tot) {
        tot = document.createElement('span'); tot.setAttribute('data-rl-pz-total', ''); tot.className = 'rl-pz-sticky-total';
        var money = box.querySelector('.price'); if (money) money.insertAdjacentElement('afterend', tot); else box.prepend(tot);
      }
      tot.textContent = '£' + ((m.price + extra) / 100).toFixed(2);
    }

    // Product page price: '£55.00' reads '£60.00' while personalisation is chosen (owner, 4 Nov).
    // The Club price beside it adds the personalisation at full price: Club never discounts it
    // (docs/club/eligibility-summary.md), so £46.75 with CLUB reads £51.75.
    function syncMain() {
      var scope = root.closest('.shopify-section') || document;
      var box = scope.querySelector('.product-page-price .price');
      if (!box || !box.classList) return;
      var m = MEDIA[variantId()], extra = any() ? price() : 0, on = !!(extra && m);
      [scope, document.querySelector('sticky-atc')].forEach(function (el) {
        if (!el || !el.querySelectorAll) return;
        el.querySelectorAll('.rlc-price .money').forEach(function (c) {
          if (!c.dataset.pzClub) c.dataset.pzClub = c.textContent.trim();
          var base = parseFloat(c.dataset.pzClub.replace(/[^0-9.]/g, ''));
          c.textContent = on && base ? '£' + (base + extra / 100).toFixed(2) : c.dataset.pzClub;
        });
      });
      var tot = box.querySelector('[data-rl-pz-main-total]');
      box.classList.toggle('rl-pz-price-on', on);
      if (!on) { if (tot) tot.remove(); return; }
      if (!tot) {
        tot = document.createElement('span'); tot.setAttribute('data-rl-pz-main-total', '');
        tot.className = 'price-item main-price rl-pz-main-total';
        box.prepend(tot);
      }
      tot.textContent = '£' + ((m.price + extra) / 100).toFixed(2);
    }

    // Bottom of the back print: the lowest bright row in the middle of the dark garment.
    function findPrint() {
      try {
        var w = 800, h = Math.round(w * base.naturalHeight / base.naturalWidth);
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var g = c.getContext('2d'); g.drawImage(base, 0, 0, w, h);
        var d = g.getImageData(0, 0, w, h).data, last = -1;
        var px = function (x, y) { var k = (y * w + x) * 4; return Math.max(d[k], d[k + 1], d[k + 2]); };
        var x0 = Math.round(w * BAND), x1 = Math.round(w * (1 - BAND));
        // Background = light pixels connected to the photo's edge. Anything else that is light is the
        // print, even where a wide design crosses x0 / x1 (the old edge test stopped there: armoured
        // designs, ANTI WHEELIE, NOT WANTED BY MILFS ... got the line through the design).
        var bg = new Uint8Array(w * h), stack = [];
        for (var e = 0; e < w; e++) stack.push(e, (h - 1) * w + e);
        for (e = 0; e < h; e++) stack.push(e * w, e * w + w - 1);
        while (stack.length) {
          var i = stack.pop();
          if (bg[i] || px(i % w, (i / w) | 0) < 110) continue;
          bg[i] = 1;
          var ix = i % w;
          if (ix > 0) stack.push(i - 1);
          if (ix < w - 1) stack.push(i + 1);
          if (i >= w) stack.push(i - w);
          if (i < w * (h - 1)) stack.push(i + w);
        }
        var ink = function (x, y) { return !bg[y * w + x] && px(x, y) > 110; };
        var lit = function (y) { for (var x = x0; x < x1; x++) if (ink(x, y)) return true; return false; };
        for (var y = Math.round(h * 0.2); y < h; y++) if (lit(y)) last = y;
        // Bottom edge of the garment: the lowest dark row in the central band (inside the hem, clear
        // of the sleeves). Only trusted when the photo is the flat shot on a light background — a
        // dark or busy lifestyle photo leaves the fallback, which simply never clamps.
        var hem = -1, hx0 = Math.round(w * 0.35), hx1 = Math.round(w * 0.65);
        for (var cx = hx0; cx < hx1; cx++) {
          for (var cy = h - 1; cy >= 0; cy--) { if (px(cx, cy) < 110) { if (cy > hem) hem = cy; break; } }
        }
        if (hem > 0 && px(5, 5) > 150 && px(w - 5, 5) > 150) garmentBottom = hem / h;
        if (last > 0) {
          printBottom = Math.min(0.85, last / h);
          // The last printed line: its height and centre.
          var top = last; while (top > 0 && lit(top - 1)) top--;
          // Two small lines set tight ('RUN IT! LONDON / EST. 2024' on the Halloween designs) touch
          // through anti-aliasing and read as one tall line: a big handle, set too far down. Split
          // at the faintest row inside the block when it is under a quarter of the busiest row.
          var rowInk = function (y) { var n = 0; for (var x = x0; x < x1; x++) if (ink(x, y)) n++; return n; };
          var rows = [], peak = 0;
          for (var ry = top; ry <= last; ry++) { rows.push(rowInk(ry)); peak = Math.max(peak, rows[rows.length - 1]); }
          if (rows.length / h < 0.03) for (var ri = rows.length - 4; ri >= 3; ri--) if (rows[ri] < peak * 0.25) { top += ri + 1; break; }
          var lineH = (last - top + 1) / h, minX = w, maxX = 0;
          for (var yy = top; yy <= last; yy++) for (var xx = x0; xx < x1; xx++) if (ink(xx, yy)) { if (xx < minX) minX = xx; if (xx > maxX) maxX = xx; }
          if (lineH > 0.008 && lineH < 0.03) { gapH = lineH * 0.9; printX = (minX + maxX) / 2 / w; }
          else { gapH = GAP * K; printX = 0.5; }
          // Footer detection determines placement only; text height never follows it.
          if (CENTRE) {
            // Midpoint of the whole print, so an off-centre footer line can't drag the handle sideways.
            var allMin = w, allMax = 0;
            for (var cyy = Math.round(h * 0.2); cyy <= last; cyy++) for (var cxx = 0; cxx < w; cxx++) if (ink(cxx, cyy)) { if (cxx < allMin) allMin = cxx; if (cxx > allMax) allMax = cxx; }
            if (allMax > allMin) printX = (allMin + allMax) / 2 / w;
          }
        }
      } catch (err) { /* keep the fallback */ }
      fitKinds();
      render();
    }
    // A design printed almost to the hem leaves no room for a handle or plate under it. Rather than
    // print over the design or onto the rib, that option is switched off for this product (owner,
    // 19 Oct: BOO! DIDN'T SEE ME? GHOST RIDER). Only when the hem was measured from a flat shot.
    function fitKinds() {
      if (garmentBottom === GARMENT_BOTTOM) return;
      var room = garmentBottom - PLATE_MARGIN - printBottom;
      var lineNeed = gapH * TEXT_GAP * GAPK + capH * ICON_RATIO;
      // Reserve the whole plate plus its under-design gap. Half-height let the
      // hem clamp push plates back over tall artwork (e.g. CATCH ME IF YOU CAN).
      var plateNeed = gapH * 1.5 * GAPK + PLATE_W * 0.9 * K * 0.782 * (base.naturalWidth / base.naturalHeight);
      var blocked = [];
      root.querySelectorAll('input[name="rl-pz-kind"]').forEach(function (input) {
        var need = input.value === 'plate' ? plateNeed : input.value ? lineNeed : 0;
        var fits = room >= need;
        input.disabled = !fits;
        var label = root.querySelector('label[for="' + input.id + '"]');
        if (label) { label.style.opacity = fits ? '' : '0.4'; label.style.cursor = fits ? '' : 'not-allowed'; label.title = fits ? '' : 'No room under this design'; }
        if (!fits) blocked.push(label ? label.firstChild.textContent.trim() : input.value);
        if (!fits && input.checked) { input.checked = false; var none = root.querySelector('input[name="rl-pz-kind"][value=""]'); if (none) none.checked = true; st.kind = ''; }
      });
      var note = root.querySelector('[data-pz-nofit]'), fs = root.querySelector('input[name="rl-pz-kind"]');
      if (!note && blocked.length && fs) { note = document.createElement('p'); note.setAttribute('data-pz-nofit', ''); note.style.cssText = 'margin:6px 0 0;font-size:12px;opacity:.7'; fs.closest('fieldset').appendChild(note); }
      if (note) note.textContent = blocked.length ? (blocked.length > 1 ? blocked.slice(0, -1).join(', ') + ' and ' + blocked[blocked.length - 1] : blocked[0]) + ': no room under this design.' : '';
    }
    base.addEventListener('load', findPrint);
    followVariant();
    if (base.complete && base.naturalWidth) findPrint();
    if (document.fonts) {
      document.fonts.load('20px RunItPersonalisation').then(function (faces) { fontReady = faces.length > 0; render(); }, function () { fontReady = false; render(); });
      document.fonts.load('20px RunItUKPlate').then(render, function () {});
    }

    // Snapshot of the finished back (photo + line), full size, for the printer.
    function snapshot() {
      // A slow connection can still leave the background image pending; wait for it
      // (max 4s) so the snapshot isn't blank.
      var ready = base.complete && base.naturalWidth ? Promise.resolve() : new Promise(function (res) {
        base.loading = 'eager'; base.addEventListener('load', res, { once: true }); setTimeout(res, 4000);
      });
      return ready.then(function () { return new Promise(function (resolve) {
        try {
          var W = base.naturalWidth, H = base.naturalHeight;
          var c = document.createElement('canvas'); c.width = W; c.height = H;
          var g = c.getContext('2d'); g.drawImage(base, 0, 0, W, H); paint(g, W, H);
          if (!W) return resolve(null);
          c.toBlob(function (b) { resolve(b); }, 'image/png');
        } catch (err) { resolve(null); }
      }); });
    }
    root.rlPzSnapshot = snapshot; // assets/runit-pz-configurator.js puts it on the product gallery
    // Tapping the preview opens the set viewer (assets/runit-armour-bundles.js) on it, zoomable.
    var view = $(root, '[data-pz-view]');
    if (view && view.addEventListener) view.addEventListener('click', function () {
      if (!window.rlAbZoom || !base.naturalWidth) return;
      var img = document.createElement('img'); img.alt = base.alt;
      try {
        var W = Math.min(2000, base.naturalWidth), H = Math.round(W * base.naturalHeight / base.naturalWidth);
        var c = document.createElement('canvas'); c.width = W; c.height = H;
        var g = c.getContext('2d'); g.drawImage(base, 0, 0, W, H); if (any()) paint(g, W, H);
        img.src = c.toDataURL('image/jpeg', 0.92);
      } catch (err) { img.src = base.currentSrc || base.src; } // a tainted canvas: the plain photo
      window.rlAbZoom([img], root.dataset.pzFor || base.alt);
    });
    function prioritisePreview() { base.fetchPriority = 'high'; }
    root.querySelector('summary').addEventListener('pointerenter', prioritisePreview);
    root.querySelector('summary').addEventListener('focusin', prioritisePreview);
    root.addEventListener('toggle', function () {
      if (root.open) { prioritisePreview(); followVariant(); }
    });

    var passing = false, adding = false;
    // A set's piece waits on its personaliser (assets/runit-armour-bundles.js); this tells it to stop.
    function fail() { root.dispatchEvent(new CustomEvent('runit:pz-fail', { bubbles: true })); }
    root.addEventListener('runit:pz-variant', followVariant); // a piece's size or finish changed
    var piece = root.hasAttribute('data-pz-piece'); // a set's piece: the set owns its button, add and clean-up
    // Every Add to Bag for this form says "Adding…" and is disabled for the whole flow.
    function busy(on) {
      if (piece) return;
      var btns = Array.prototype.slice.call(form.querySelectorAll('button[type="submit"], [data-bundle-add]'));
      if (scope === document) btns = btns.concat(Array.prototype.slice.call(document.querySelectorAll('sticky-atc .main-product-atc, [data-bundle-add]')));
      btns.forEach(function (b) {
        // Only a text node's own label: the sticky label also holds the theme's error and price nodes.
        var label = b.querySelector('.main-atc__label__text, .sticky-atc__label__text') || (b.children.length ? null : b);
        if (on && !b.hasAttribute('data-pz-busy')) {
          b.setAttribute('data-pz-busy', JSON.stringify({ d: b.disabled, t: label ? label.textContent : null }));
          b.disabled = true; if (label) label.textContent = 'Adding…';
        } else if (!on && b.hasAttribute('data-pz-busy')) {
          var was = JSON.parse(b.getAttribute('data-pz-busy'));
          b.removeAttribute('data-pz-busy');
          b.disabled = was.d; if (label && was.t !== null) label.textContent = was.t;
        }
      });
    }
    function cart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
    // After the hand-off: true once the garment (properties._pz) is in the bag; false when the theme
    // reported an error, the add-on already went (a set's own roll-back), or nothing landed in 15s
    // with the theme's add no longer in flight (its button's aria-disabled; hard stop at 45s).
    function garmentLanded(uid) {
      var start = Date.now(), pf = form.closest('product-form');
      var inFlight = function () { var b = form.querySelector('button[name="add"]'); return !!b && b.getAttribute('aria-disabled') === 'true'; };
      return new Promise(function (resolve) {
        (function tick() {
          var late = Date.now() - start > 15000 && (!inFlight() || Date.now() - start > 45000);
          cart().then(function (c) {
            var mine = function (k) { return c.items.some(function (i) { return i.properties && i.properties[k] === uid; }); };
            if (mine('_pz')) return resolve(true);
            var err = pf && pf.querySelector('.product-form__error-message-wrapper:not([hidden])');
            if (!mine('_pz_for') || err || late) return resolve(false);
            setTimeout(tick, 500);
          }, function () { if (late) resolve(false); else setTimeout(tick, 500); });
        })();
      });
    }
    // No paid personalisation line may reach checkout without its garment: both go together.
    // Resolves true once the bag holds neither line (one retry).
    function rollback(uid, retry) {
      return cart().then(function (c) {
        var updates = {}, n = 0;
        c.items.forEach(function (i) { var p = i.properties || {}; if (p._pz_for === uid || p._pz === uid) { updates[i.key] = 0; n++; } });
        if (!n) return true;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
          .then(function (r) { if (!r.ok) throw new Error('rollback'); return true; });
      }).catch(function () { return retry ? false : rollback(uid, true); });
    }
    form.addEventListener('submit', function (e) {
      if (passing || !any()) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (adding) return; // a second tap must not add a second paid line or relink the garment
      var p = lineError() || (st.kind && !content() ? ({ instagram: 'Add your Instagram handle first.', text: 'Add your text first.', plate: 'Add your plate first.' })[st.kind]
        : !inAgree.checked ? AGREE_MSG : '');
      if (p === AGREE_MSG) { agreeErr = true; render(); }
      if (p) { fail(); msg.textContent = p; root.open = true; msg.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      var c = combo();
      if (!c) { fail(); msg.textContent = 'Personalisation is unavailable right now. Please try again later.'; return; }
      adding = true; busy(true);
      // One shared id ties the garment line (_pz) to its single personalisation line (_pz_for).
      var uid = 'pz' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      set('uid', uid);
      (window.RLPZ_PENDING = window.RLPZ_PENDING || {})[uid] = Date.now(); // assets/runit-pz-sync.js waits for the garment
      var title = ((scope.querySelector('.product__title h1, h1') || {}).textContent || '').trim();
      var size = ((form.querySelector('[name="id"]') || {}).value || '');
      var opts = Array.prototype.map.call(scope.querySelectorAll('.product-form__input:not(.rl-pz__group) input:checked'), function (i) { return i.value; }).join(' / ');
      if (opts) title += ' (' + opts + ')';
      if (root.dataset.pzFor) title = root.dataset.pzFor; // a set's piece names itself, not the page's product
      var detail = [
        st.kind && (st.kind === 'instagram' ? '@' + st.ig : st.kind === 'plate' ? 'plate ' + plateText() : '“' + st.text.trim() + '”') + (st.refl && st.kind !== 'plate' ? ', Reflective' : ''),
        st.stars && st.stars + ' ' + starColName() + ' Stars'
      ].filter(Boolean).join(' + ');
      var added = false;
      // The snapshot rides on the personalisation line as a file property (multipart /cart/add.js):
      // the theme's own add-to-cart serialises the form without files, so it can't carry it.
      snapshot().then(function (blob) {
        var fd = new FormData();
        fd.append('id', c.id);
        fd.append('quantity', +((form.querySelector('[name="quantity"]') || {}).value || 1));
        fd.append('properties[For]', title);
        fd.append('properties[Design]', detail);
        fd.append('properties[_pz_for]', uid);
        fd.append('properties[_variant]', size);
        if (blob) fd.append('properties[Preview]', blob, 'personalisation-preview.png');
        return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        added = true;
        passing = true;
        try { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
        finally { passing = false; }
        if (piece) return true; // the set adds every garment at once and rolls back on failure
        // The page's own add (theme or Just The One) runs on: the add-on is only kept once the garment lands.
        return garmentLanded(uid).then(function (ok) {
          if (ok) return true;
          return rollback(uid).then(function (clean) { throw new Error(clean ? 'garment' : 'stuck'); });
        });
      }).catch(function (err) {
        fail();
        msg.textContent = !added ? 'Personalisation could not be added. Please try again.'
          : err && err.message === 'stuck' ? 'Your item could not be added to your bag. Please remove the personalisation line from your bag and try again.'
          : 'Your item could not be added to your bag, so the personalisation was not charged. Please try again.';
      }).then(function () {
        if (!piece && window.RLPZ_PENDING) delete window.RLPZ_PENDING[uid];
        adding = false; busy(false);
      });
    }, true);

    render();
  }
  initAll();
  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
})();
